/* eslint-disable */

import React from 'react'
import ChargePointEditDetails from './Components/ChargePointEditDetails'
import ChargePointEditAC from './Components/ChargePointEditAC'
import { error } from 'console'

const ChargePointEdit = () => {
  return (
    <div>
      <div className='card card-custom'>
        <div className='card-header d-flex justify-content-center bg-success'>
          <h3 className='card-title text-white'>EDIT CHARGE POINT</h3>
        </div>
        <div className='card-body'>
          <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mt-8 mb-8 fs-4'>
            <li className='nav-item'>
              <a className='nav-link active' data-bs-toggle='tab' href='#kt_tab_pane_4'>
                Details
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link' data-bs-toggle='tab' href='#kt_tab_pane_5'>
                Account Details
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link' data-bs-toggle='tab' href='#kt_tab_pane_6'>
                Gallery
              </a>
            </li>
          </ul>
          <div className='tab-content' id='myTabContent'>
            <div className='tab-pane fade show active' id='kt_tab_pane_4' role='tabpanel'>
              <ChargePointEditDetails />
            </div>
            <div className='tab-pane fade' id='kt_tab_pane_5' role='tabpanel'>
             <ChargePointEditAC />
            </div>
            <div className='tab-pane fade' id='kt_tab_pane_6' role='tabpanel'>
              Gallery Page
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargePointEdit
